// AntiSlavery.js
'use strict';
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import AntiSlavery from '../component/AntiSlavery.jsx';
import sendMailToFallback from '../action/sendMailToFallback.js';

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    handleMailTo: () => dispatch(sendMailToFallback()),
  };
};

export default connect(null, mapDispatchToProps)(AntiSlavery);
